module.exports = __webpack_public_path__ + "assets/pie_israel-35af29.svg";